/**
 * Moyens de paiement au moment de la livraison (notes livreur, même codification que les modes commande).
 */
export const ORDER_PAYMENT_SETTLEMENT_OPTIONS = [
  { code: "CB", label: "Carte bancaire" },
  { code: "ESP", label: "Espèce" },
  { code: "CHQ", label: "Chèque" },
  { code: "TKT", label: "Ticket restaurant" },
  { code: "CARTE TKT", label: "Carte ticket restaurant" },
  { code: "VRT", label: "Virement" },
  { code: "PLUS_TARD", label: "Le client règlera plus tard" },
] as const;

export type OrderPaymentSettlementCode =
  (typeof ORDER_PAYMENT_SETTLEMENT_OPTIONS)[number]["code"];
